import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { useRouter } from 'next/router';

import { useHttp } from '../../hooks/network';
import { useTranslation } from '../../hooks/translation';
import AppContainer from '../AppContainer/AppContainer';
import AppImage from '../AppImage';
import AppButton from '../AppButton/AppButton';
import AppModal from '../AppModal/AppModal';
import AppLink from '../AppLink';
import { useAppStateContext } from '../../hooks/context';
import { normalizeServerUrl } from '../../utils/url';

import styles from './AppTeam.module.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import Birthdaybox from './Birthdaybox';

export default function AppTeam({ team }) {
  const { menu } = useAppStateContext().context;
  const { translate } = useTranslation();
  const { locale } = useRouter();
  const { request } = useHttp({ locale });

  const [open, setOpen] = useState(false);
  const [activeModal, setActiveModal] = useState([]);
  const [teamsData, setTeamsData] = useState(null);

  const contact = menu?.data?.filter(
    (item) => item?.position === 'top' && (item?.page_slug === 'contact' || item?.page_slug === 'კონტაქტი'),
  );

  const fetchTeams = async () => {
    const response = await request({
      url: 'teams',
    });
    setTeamsData(response.data);
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  return (
    <div className={styles.AppTeam}>
      <AppContainer>
        <div className={styles.AppTeam_Header}>
          <div className={styles.AppTeam_Content}>
            <h1 className={styles.AppTeam_Title}>{team.title}</h1>
            <h2 className={styles.AppTeam_SubTitle}>{team.sub_title}</h2>
            <div className={styles.AppTeam_Desc}>
              <p>{team.desc}</p>
            </div>
            <AppLink href={normalizeServerUrl((contact[ 0 ].page_slug))} ariaLabel={translate('team_button')} title={translate('team_button')}>
              <AppButton round>{translate('team_button')}</AppButton>
            </AppLink>
          </div>
          <div className={styles.AppTeam_Image}>
            <div className={styles.AppTeam_Image_Dots}>
              <AppImage objectFit="fill" src="/images/team-dots.svg" />
            </div>
            <div className={styles.AppTeam_Image_Group}>
              <AppImage objectFit="fill" src="/images/team-group.svg"  />
            </div>
            <div className={styles.AppTeam_Image_Lines}>
              <AppImage objectFit="fill" src="/images/team-lines.svg" />
            </div>
          </div>
        </div>
      </AppContainer>
      <div className={styles.AppTeam_Slider_Wrapper}>
        <AppContainer>
          <div className={styles.AppTeam_Slider_Inner}>
            <Swiper
              className={'appteam_slider'}
              slidesPerView={4}
              spaceBetween={30}
              modules={[Navigation]}
              speed={300}
              navigation={{
                nextEl: '.AppTeam_Slider_Prev',
                prevEl: '.AppTeam_Slider_Next',
              }}
              breakpoints={{
                1440: {
                  spaceBetween: 32,
                  slidesPerView: 4,
                },
                1000: {
                  spaceBetween: 32,
                  slidesPerView: 3,
                },
                720: {
                  spaceBetween: 24,
                  slidesPerView: 2.5,
                },
                320: {
                  spaceBetween: 24,
                  slidesPerView: 1,
                },
              }}>
              {teamsData?.data.map((item, i) => (
                <SwiperSlide key={i}>
                  <div className={styles.AppTeam_Slider}>
                    <div className={styles.AppTeam_SliderItem}>
                      <div className={styles.AppTeam_Slider_Image}>
                        <div className={styles.AppTeam_Slider_Image_Frame}>
                          <Frame />
                          <AppImage src={'/images/frame.png'} fill/>
                        </div>
                        <div
                          className={styles.AppTeam_Slider_Image_Person}
                          onClick={() => {
                            setOpen(true);
                            setActiveModal(item);
                          }}>
                          <AppImage src={item.image.url} alt={item.full_name} />
                        </div>
                      </div>
                      <div className={styles.AppTeam_Slider_Content}>
                        <h3 className={styles.AppTeam_Slider_Name}>{item.full_name}</h3>
                        <div
                          className={styles.AppTeam_Slider_More}
                          onClick={() => {
                            setOpen(true);
                            setActiveModal(item);
                          }}>
                          <Plus />
                        </div>
                      </div>
                      <div className={styles.AppTeam_Slider_Position}>{item.position}</div>
                      <div className={styles.AppTeam_Slider_Desc}>{item.desc}</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </AppContainer>
        <div className="AppTeam_Slider_Navigarion">
          <div className="AppTeam_Slider_Next">
            <AppButton round icon="arrow_left" />
          </div>
          <div className="AppTeam_Slider_Prev">
            <AppButton round icon="arrow_right" />
          </div>
        </div>
      </div>
      <Birthdaybox />

      {activeModal && (
        <AppModal open={open} setOpen={setOpen}>
          <div className={styles.AppTeam_Modal}>
            <div
              className={styles.AppTeam_Modal_Close}
              onClick={() => {
                setOpen(false);
              }}>
              <AppButton round icon="close" />
            </div>
            <div className={styles.AppTeam_Modal_Inner}>
              <div className={styles.AppTeam_Modal_Head}>
                <div className={styles.AppTeam_Left}>
                  <h2>{activeModal.full_name}</h2>
                  <div className={styles.AppTeam_Position}>{activeModal?.position}</div>
                </div>
                <div className={styles.AppTeam_Right}>
                  <div className={styles.AppTeam_Modal_Image}>
                    <div className={styles.AppTeam_Modal_Image_Frame}>
                      <Frame />
                    </div>
                    <div className={styles.AppTeam_Modal_Image_Person}>
                      <AppImage src={activeModal.image?.url} />
                    </div>
                  </div>
                </div>
              </div>
              <h3 className={styles.AppTeam_Info_Title}>{translate('team_info_title')}</h3>
              <div
                className={styles.AppTeam_Info_Desc}
                dangerouslySetInnerHTML={{ __html: activeModal?.biography }}></div>
            </div>
          </div>
        </AppModal>
      )}
    </div>
  );
}

function Frame() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 278 258">
      <g filter="url(#a)">
        <rect width="270" height="250" fill="#fff" rx="12" />
        <path
          fill="#000"
          d="M8.915 3h252.17c.584 0 1.164.073 1.74.225a7.36 7.36 0 0 1 1.673.66c.54.293 1.052.654 1.541 1.078.484.43.936.911 1.352 1.45.412.545.78 1.131 1.108 1.77.325.639.601 1.31.825 2.016a14.954 14.954 0 0 1 .676 4.466V40H0V14.665a14.964 14.964 0 0 1 .676-4.466c.224-.707.5-1.377.825-2.016.328-.638.696-1.225 1.108-1.77.416-.539.864-1.02 1.352-1.45a8.62 8.62 0 0 1 1.541-1.078 7.374 7.374 0 0 1 1.673-.66A6.801 6.801 0 0 1 8.915 3Z"
        />
        <path
          fill="#E31B54"
          d="M31.338 18.541c0 .459-.046.907-.135 1.355a6.895 6.895 0 0 1-1.031 2.494 6.986 6.986 0 0 1-1.912 1.912c-.38.255-.78.469-1.198.64a6.888 6.888 0 0 1-2.651.526 6.773 6.773 0 0 1-2.651-.526 6.617 6.617 0 0 1-1.197-.64c-.38-.25-.73-.537-1.047-.86a6.986 6.986 0 0 1-.865-1.052 6.895 6.895 0 0 1-1.031-2.495 6.946 6.946 0 0 1-.136-1.354c0-.453.047-.9.136-1.349a6.895 6.895 0 0 1 1.031-2.494c.255-.38.542-.73.865-1.052.317-.323.666-.61 1.047-.86.38-.255.776-.468 1.197-.64a6.773 6.773 0 0 1 2.651-.526 6.888 6.888 0 0 1 4.896 2.026 6.982 6.982 0 0 1 1.506 2.25c.171.416.302.849.39 1.296a6.9 6.9 0 0 1 .136 1.35Z"
        />
        <path
          fill="#F79009"
          d="M54.891 18.541c0 .459-.041.907-.13 1.355-.089.448-.224.88-.396 1.296a6.449 6.449 0 0 1-.64 1.198c-.25.38-.542.73-.86 1.052-.323.323-.672.61-1.052.86a6.449 6.449 0 0 1-1.198.64 6.66 6.66 0 0 1-1.297.396c-.448.089-.895.13-1.354.13a6.889 6.889 0 0 1-5.755-3.078 6.449 6.449 0 0 1-.64-1.198 6.946 6.946 0 0 1-.531-2.651 6.935 6.935 0 0 1 1.171-3.843 6.856 6.856 0 0 1 3.104-2.552 6.889 6.889 0 0 1 2.651-.526c.459 0 .906.041 1.354.13.443.088.88.219 1.297.396.422.171.823.385 1.198.64.38.25.73.537 1.052.86.318.323.61.671.86 1.052.255.375.468.776.64 1.198.172.416.307.849.396 1.296.089.448.13.896.13 1.35Z"
        />
        <path
          fill="#58CC02"
          d="M78.442 18.541c0 .459-.047.907-.135 1.355a6.895 6.895 0 0 1-1.032 2.494 6.93 6.93 0 0 1-.864 1.052c-.318.323-.667.61-1.047.86-.38.255-.776.469-1.198.64a6.773 6.773 0 0 1-2.651.527 6.888 6.888 0 0 1-4.896-2.027 6.985 6.985 0 0 1-.864-1.052 6.903 6.903 0 0 1-1.031-2.495 6.946 6.946 0 0 1-.136-1.354c0-.453.047-.9.135-1.349a6.903 6.903 0 0 1 1.032-2.494 6.981 6.981 0 0 1 1.911-1.912 6.62 6.62 0 0 1 1.198-.64 6.888 6.888 0 0 1 2.651-.526 6.773 6.773 0 0 1 2.651.526c.422.171.818.385 1.198.64.38.25.73.537 1.047.86a6.982 6.982 0 0 1 1.505 2.25c.172.416.302.849.39 1.296.09.448.136.896.136 1.35Z"
        />
        <rect width="267" height="247" x="1.5" y="1.5" stroke="#000" rx="10.5" />
      </g>
      <defs>
        <filter id="a" width="278" height="258" x="0" y="0">
          <feFlood result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="8" dy="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1309_15875" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

function Plus() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
      <path
        stroke="#101828"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 13V1m4 6h2M1 7h5.66"
      />
    </svg>
  );
}
